import React, { useState } from 'react';
import '../../styles/ServiceFAQ.css';
import { Plus, Minus } from 'lucide-react';


interface FAQ {
  question: string;
  answer: string;
}

interface ServiceFAQProps {
  title?: string;
  faqs: FAQ[];
}

const ServiceFAQ: React.FC<ServiceFAQProps> = ({ 
  title = "Frequently Asked Questions", 
  faqs 
}) => {
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());

  const toggleFAQ = (index: number) => {
    const newExpandedItems = new Set(expandedItems);
    if (newExpandedItems.has(index)) {
      newExpandedItems.delete(index);
    } else {
      newExpandedItems.add(index);
    }
    setExpandedItems(newExpandedItems);
  };

  return (
    <section className="service-faq-f">
      <div className="service-faq-content-f">
        <p className='faq-question-title'>{title}</p>
        
        <div className="faq-container-f">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item-f ${expandedItems.has(index) ? 'active' : ''}`}
            >
              <button
                className="faq-question-f"
                onClick={() => toggleFAQ(index)}
                aria-expanded={expandedItems.has(index)}
              >
                <span className='question'>{faq.question}</span>
                <span className="faq-icon-f">
                  {expandedItems.has(index) ? <Minus size={21} /> : <Plus size={21} />}
                </span>
              </button>
              
              <div className={`faq-answer-f ${expandedItems.has(index) ? 'expanded' : 'collapsed'}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceFAQ; 